import { whatsAppRepository } from '../repositories/whatsapp';
import { WhatsAppRepository } from '../repositories/whatsapp/WhatsAppRepository';

export class WhatsAppService {
  constructor(private whatsAppRepository: WhatsAppRepository) {}

  async createWhatsAppSender({
    subaccountName,
    phone,
    wabaId,
    name,
    address,
    logoUrl,
    description,
    about,
    emails,
    websites,
  }: {
    subaccountName: string;
    phone: string;
    wabaId: string;
    name: string;
    address?: string;
    logoUrl?: string;
    description?: string;
    about?: string;
    emails?: string[];
    websites?: string[];
  }): Promise<void> {
    await this.whatsAppRepository.createWhatsAppSender({
      subaccountName,
      phone,
      wabaId,
      name,
      address,
      logoUrl,
      description,
      about,
      emails,
      websites,
    });
  }

  async retrieveMetaPhone({
    phone_id,
    code,
    auth_token,
    redirect_uri,
  }: {
    phone_id: string;
    code?: string;
    auth_token?: string;
    redirect_uri: string;
  }): Promise<string> {
    return await this.whatsAppRepository.retrieveMetaPhone({
      phone_id,
      code,
      auth_token,
      redirect_uri,
    });
  }
}

export const whatsAppService = new WhatsAppService(whatsAppRepository);
